import { useAddETSTicketRatingMutation } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import type { FetchETSTicketRatingResponseData } from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { useState } from 'react';
import PopUpModal from '../../PopUpModal/PopUpModal';
import TicketRatingModal from './TicketRatingModal/TicketRatingModal';
import styles from './styles.module.scss';

interface TicketRatingProps {
  ticketId: string;
  ticketStatus: string;
  comment: FetchETSTicketRatingResponseData['comment'];
  rating: FetchETSTicketRatingResponseData['rating'];
  onRatingAdded: VoidFunction;
}

const TicketRating = (props: TicketRatingProps) => {
  const { ticketId, ticketStatus, comment, rating, onRatingAdded } = props;
  const buttonStyle = ticketStatus === 'wont_do' ? styles.ratingPrimaryButton : styles.ratingSecondaryButton;
  const ratingText = rating ? 'Ihre Bewertung ändern' : 'Bewerten Sie uns';
  const [showRatingModal, setRatingModal] = useState(false);
  const addETSTicketRating = useAddETSTicketRatingMutation();

  const rate = async (newRating: number, newComment: string) => {
    try {
      await addETSTicketRating.mutateAsync({
        path: {
          ticket_id: ticketId,
        },
        body: {
          rating: newRating,
          comment: newComment,
        },
      });
      onRatingAdded();
    } catch (_e) {
      // Nothing needed
    }
    setRatingModal(false);
  };

  return (
    <div className={styles.ticketRating}>
      <button type="button" className={buttonStyle} onClick={() => setRatingModal(true)}>
        <div className={styles.ratingText}>
          <span>{ratingText}</span>
          {rating && (
            <div className={styles.ratingBadge}>
              ({rating}
              <IconComponent Icon={ICON.STAR_FILLED} size={ICON_SIZE.SMALL} color={ICON_COLOR.YELLOW} />)
            </div>
          )}
        </div>
      </button>
      {showRatingModal && (
        <PopUpModal
          onRequestClose={() => setRatingModal(false)}
          isOpen
          title=""
          /** We need to be higher than the ticket dashboard drawer with z-index 10 */
          zIndex={20}
        >
          <TicketRatingModal
            rating={rating}
            comment={comment}
            onCancel={() => setRatingModal(false)}
            handleRating={rate}
          />
        </PopUpModal>
      )}
    </div>
  );
};

export default TicketRating;
